export * from './DocPlusIcon';
export * from './DocPlusIcon16Light';
export * from './DocPlusIcon16Regular';
export * from './DocPlusIcon16Solid';
export * from './DocPlusIcon20Light';
export * from './DocPlusIcon20Regular';
export * from './DocPlusIcon20Solid';
export * from './DocPlusIcon24Regular';
export * from './DocPlusIcon24Solid';
export * from './DocPlusIcon32Regular';
export * from './DocPlusIcon64Regular';
